import { escapeHtml } from '../../utilities/index.js';

const customerAddressForm = () => ({
  setDefaultCountry() {
    const { countrySelect } = this.$refs;

    const defaultCountry = countrySelect.dataset.default;
    if (defaultCountry) {
      countrySelect.value = defaultCountry;
    }
  },

  setDefaultProvince() {
    const { provinceSelect } = this.$refs;

    const defaultProvince = provinceSelect.dataset.default;
    if (defaultProvince) {
      provinceSelect.value = defaultProvince;
    }
  },

  /**
   * Update provinces options based on selected country
   */
  updateProvinces() {
    const { countrySelect, provinceSelect, provinceField } = this.$refs;
    const country = countrySelect[countrySelect.selectedIndex];

    if (!country) {
      return;
    }

    const provinces = JSON.parse(country.dataset.provinces);
    provinceSelect.innerHTML = '';
    provinceSelect.value = '';

    if (!provinces.length) {
      provinceField.classList.add('is-hidden');
      return;
    }

    provinceField.classList.remove('is-hidden');
    provinceSelect.innerHTML = provinces
      .map(
        (province) =>
          `<option value="${escapeHtml(province[0])}">${escapeHtml(
            province[1]
          )}</option>`
      )
      .join('');
  },

  init() {
    this.setDefaultCountry();
    this.updateProvinces();
    this.setDefaultProvince();
  },
});

export default customerAddressForm;
